// extracted by mini-css-extract-plugin
module.exports = {"nets-settings":"NetsConfiguration_nets-settings__2uqku"};